export const authErrorMessages: Record<string, string> = {
  // Supabase Auth エラーコード
  invalid_credentials: "メールアドレスまたはパスワードが正しくありません",
  user_not_found: "ユーザーが見つかりません",
  email_not_confirmed: "メールアドレスが確認されていません。確認メールをご確認ください",
  otp_expired: "ワンタイムパスワードの有効期限が切れています。再度送信してください",
  invalid_otp: "ワンタイムパスワードが正しくありません",
  rate_limit: "リクエストが多すぎます。しばらく待ってから再度お試しください",
  user_already_exists: "このメールアドレスは既に登録されています",
  weak_password: "パスワードが弱すぎます。より強力なパスワードを設定してください",
  invalid_email: "有効なメールアドレスを入力してください",
  email_change_needs_reauthentication: "メールアドレスの変更には再認証が必要です",
  password_recovery_required: "パスワードのリセットが必要です",

  // OAuth エラー
  oauth_error: "OAuth認証に失敗しました",
  provider_email_needs_verification: "プロバイダのメールアドレスの確認が必要です",

  // ネットワークエラー
  network_error: "ネットワークエラーが発生しました。インターネット接続を確認してください",
  server_error: "サーバーエラーが発生しました。しばらく待ってから再度お試しください",
  timeout: "リクエストがタイムアウトしました。もう一度お試しください",

  // 権限エラー
  insufficient_permissions: "この操作を実行する権限がありません",
  admin_only: "管理者権限が必要です",

  // セッションエラー
  session_expired: "セッションの有効期限が切れました。再度ログインしてください",
  invalid_session: "セッションが無効です。再度ログインしてください",

  // デフォルト
  unknown_error: "予期しないエラーが発生しました。しばらく待ってから再度お試しください",
};

export function getAuthErrorMessage(error: any): string {
  if (!error) return authErrorMessages.unknown_error;

  // Supabase エラーオブジェクトの処理
  if (error.code && authErrorMessages[error.code]) {
    return authErrorMessages[error.code];
  }

  // エラーメッセージに含まれるキーワードで判定
  const errorMessage = error.message?.toLowerCase() || "";

  if (errorMessage.includes("invalid") && errorMessage.includes("credentials")) {
    return authErrorMessages.invalid_credentials;
  }
  if (errorMessage.includes("rate limit")) {
    return authErrorMessages.rate_limit;
  }
  if (errorMessage.includes("network")) {
    return authErrorMessages.network_error;
  }
  if (errorMessage.includes("timeout")) {
    return authErrorMessages.timeout;
  }
  if (errorMessage.includes("otp") && errorMessage.includes("expired")) {
    return authErrorMessages.otp_expired;
  }
  if (errorMessage.includes("session") && errorMessage.includes("expired")) {
    return authErrorMessages.session_expired;
  }

  // カスタムメッセージが設定されている場合はそれを返す
  if (error.message && error.message.length < 100) {
    return error.message;
  }

  return authErrorMessages.unknown_error;
}
